import HeaderTeamLogo from '../components/HeaderTeamLogo';
import { useEffect, useState } from "react";
import axios from 'axios';

export default function HeaderTeamLogos({endpointUrl}) {
    const [teams, setTeams] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
      axios.get(endpointUrl + 'data-endpoint/team-logos')
      .then(response => {
        setTeams(response.data);
        setIsLoading(false);
      })
      .catch(error => {
        console.error(error);
        setIsLoading(false);
      });
    }, []);
    if (!isLoading) {
        return (
            <>
                <HeaderTeamLogo teams={teams} isLoading={isLoading} />
            </>
        );
    }
  }